<router-outlet class="root-page"/>
<app-cookie-banner></app-cookie-banner>